import LoginForm from "@components/ui/LoginForm";
import LanguageSelector from "@components/ui/LanguageSelector";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid/Grid";
import HeroSection from "@pages/login/HeroSection";
import { DASHBOARD_PATH } from "@routes/path";
import type { ILoginInput } from "@services/api/authentication/login/interface";
import handleLogin from "@services/authentication/handleLogin";
import verifyEmail from "@services/api/authentication/verify-email/verifyEmail";
import { ACCESS_TOKEN_KEY } from "@services/api/constants";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import translations from "./translations.json";

type SupportedLanguage = keyof typeof translations;

const LoginPage = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;

    const handleSubmit = async (input: ILoginInput) => {
        const response = await handleLogin(input);
        return response;
    };

    const handleVerify = async ({ email, code }: { email: string; code: string }) => {
        const response = await verifyEmail(email, code);
        const authData = response.data;

        if (!authData?.verified || !authData.token) {
            throw new Error(content.missingToken);
        }

        localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify({
            token: authData.token,
            expiresAt: authData.expiresAt || Date.now() + 15 * 60 * 1000,
            type: "recruiter",
        }));

        const redirectTarget = sessionStorage.getItem('redirect_target_url');
        if (redirectTarget) {
            sessionStorage.removeItem('redirect_target_url');
            navigate(redirectTarget);
        } else {
            navigate(DASHBOARD_PATH);
        }
    };

    return (
        <Box sx={{ position: "relative", minHeight: "100vh", backgroundColor: "#0f1319" }}>
            <Box sx={{ position: "absolute", top: 24, right: 24, zIndex: 10 }}>
                <LanguageSelector />
            </Box>
            <Grid container sx={{ minHeight: '100vh', backgroundColor: '#0f1319' }}>
                {/* Section Visuelle Gauche */}
                <HeroSection />

                {/* Formulaire Droite */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#0f1319', // Fond sombre
                        p: { xs: 4, md: 8 },
                    }}
                >
                    <LoginForm onSubmit={handleSubmit} onVerify={handleVerify} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default LoginPage;